export default __webpack_public_path__ + "static/media/Search.a30b2df5.svg";